import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Arise4uBlackLogo from '../../assets/images/logo/arise logo-01 1.svg';

import LandingPowerHCLTechLogo from '../../assets/images/Hcl.svg';
import LandingPowerCareerShaperLogo from '../../assets/images/career.svg';
import LandingPowerPearsonLogo from '../../assets/images/pearson.svg';
import LandingPowerMeitylogo from '../../assets/images/meity.svg';

import '../../assets/styles/LandingHeader.css';

const LandingHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);

    if (isMenuOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <>
      <nav className={`landing-header-navbar ${isScrolled ? 'landing-header-scrolled' : ''}`}>
        <div className="landing-header-container">
          <div className="landing-header-logo">
            <Link to="#">
              <img src={Arise4uBlackLogo} alt="Arise4u Logo" className="landing-header-logo-img" />
            </Link>
          </div>

          <button
            className={`landing-header-toggler ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            <span className="landing-header-toggler-icon">
              <span className="landing-header-bar"></span>
              <span className="landing-header-bar"></span>
              <span className="landing-header-bar"></span>
            </span>
          </button>

          <div className={`landing-header-nav-box ${isMenuOpen ? 'landing-header-show' : ''}`}>
            <ul className="landing-header-nav">
              <li><img src={LandingPowerHCLTechLogo} alt="HCLTech Logo" /></li>
              <li><img src={LandingPowerCareerShaperLogo} alt="CareerShaper Logo" /></li>
              <li><img src={LandingPowerPearsonLogo} alt="Pearson Logo" /></li>
              <li><img src={LandingPowerMeitylogo} alt="Meity Logo" /></li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="landing-header-spacer"></div>
    </>
  );
};

export default LandingHeader;
















// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import Arise4uBlackLogo from '../../assets/images/logo/arise logo-01 1.svg';

// import LandingPowerHCLTechLogo from '../../assets/images/Hcl.svg';
// import LandingPowerCareerShaperLogo from '../../assets/images/career.svg';
// import LandingPowerPearsonLogo from '../../assets/images/pearson.svg';
// import LandingPowerMeitylogo from '../../assets/images/meity.svg';

// import '../../assets/styles/LandingHeader.css';

// const LandingHeader = () => {
//   const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 10);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <>
//       <nav className={`landing-header-navbar ${isScrolled ? 'landing-header-scrolled' : ''}`}>
//         <div className="landing-header-container">
//           {/* Logo */}
//           <div className="landing-header-logo">
//             <Link to="#">
//               <img src={Arise4uBlackLogo} alt="Arise4u Logo" className="landing-header-logo-img" />
//             </Link>
//           </div>

//           {/* Nav Logos */}
//           <div className="landing-header-nav-box">
//             <ul className="landing-header-nav landing-header-logos-grid">
//               <li><img src={LandingPowerHCLTechLogo} alt="HCLTech Logo" /></li>
//               <li><img src={LandingPowerCareerShaperLogo} alt="CareerShaper Logo" /></li>
//               <li><img src={LandingPowerPearsonLogo} alt="Pearson Logo" /></li>
//               <li><img src={LandingPowerMeitylogo} alt="Meity Logo" /></li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//       <div className="landing-header-spacer"></div>
//     </>
//   );
// };

// export default LandingHeader;



/* Navbar container */
// .landing-header-navbar {
//   position: fixed;
//   width: 100%;
//   top: 0;
//   left: 0;
//   background: white;
//   z-index: 999;
//   transition: all 0.3s ease;
//   box-shadow: 0 2px 10px rgba(0,0,0,0.1);
// }

// .landing-header-scrolled {
//   box-shadow: 0 4px 16px rgba(0,0,0,0.15);
// }

// /* Container */
// .landing-header-container {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   max-width: 1400px;
//   margin: 0 auto;
//   padding: 0.1rem 0.5rem;
// }

// /* Logo */
// .landing-header-logo-img {
//   height: 100px;
//   width: auto;
//   margin-right: auto;
// }

// /* Nav menu (desktop) */
// .landing-header-nav-box {
//   display: flex;
// }

// .landing-header-nav {
//   display: flex;
//   list-style: none;
//   gap: 4rem;
//   margin: 0;
//   padding: 0;
//   align-items: center;
// }

// .landing-header-nav li img {
//   height: 30px;
//   width: auto;
// }

// /* Spacer */
// .landing-header-spacer {
//   height: 70px;
// }

// /* Responsive: mobile 2x2 logos */
// @media screen and (max-width: 768px) {
//   /* Make logos 2x2 grid */
//   .landing-header-nav {
//     display: grid;
//     grid-template-columns: repeat(2, 1fr);
//     gap: 1rem;
//     padding: 0.5rem;
//     justify-items: center;
//     align-items: center;
//   }

//   .landing-header-nav li img {
//     height: 50px; /* smaller logos for mobile */
//     width: auto;
//   }

//   /* Hide hamburger (optional) */
//   .landing-header-toggler {
//     display: none;
//   }

//   /* Remove sliding menu styles */
//   .landing-header-nav-box {
//     position: static;
//     height: auto;
//     width: 100%;
//     background: none;
//     box-shadow: none;
//     transform: none;
//     padding: 0;
//   }
// }
